export default "__VITE_ASSET__Nj9CZBq0__"